import { render, staticRenderFns } from "./MenuProjeto.vue?vue&type=template&id=4d4d889a&"
import script from "./MenuProjeto.vue?vue&type=script&lang=js&"
export * from "./MenuProjeto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports